import { Theme, makeStyles, createStyles } from '@material-ui/core';

export const LayoutStyles = makeStyles((theme: Theme) =>
  createStyles({
    screenContainer: {
      '& #root > footer, #root > .icp-recordal-footer': {
        display: 'none',
      },
      '& .noExitonHeader > header > div > button, .noExitonHeader > header > div > div:nth-child(2)': {
        display: 'none',
      },
      '& #root > .main-content': {
        minHeight: 'calc(100vh - 40px) !important',
        [theme.breakpoints.up('md')]: {
          minHeight: 'calc(100vh - 50px) !important',
        },
      },
    },
  }),
);
